import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "qa-qc-bg" }, null, -1)
const _hoisted_2 = { class: "ref-text-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlaceholderParagraph = _resolveComponent("PlaceholderParagraph")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Aspect = _resolveComponent("Aspect")!

  return (_openBlock(), _createBlock(_component_Aspect, {
    aspectRatio: 2 / 1,
    initialWidth: 200,
    class: "qa-quiz-card"
  }, {
    default: _withCtx(({ scale }) => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        (_ctx.refText && (!_ctx.spinner || !!_ctx.verseText))
          ? (_openBlock(), _createElementBlock("p", {
              key: 0,
              class: _normalizeClass(["ref-text", { 'qa-qc-ref--with-verse': !!_ctx.verseText }]),
              style: _normalizeStyle({ lineHeight: `${scale}em` })
            }, [
              _createElementVNode("span", {
                style: _normalizeStyle({ fontSize: `${scale}em` })
              }, _toDisplayString(_ctx.refText), 5)
            ], 6))
          : _createCommentVNode("", true),
        (_ctx.verseText && !_ctx.spinner)
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              class: "verse-text",
              style: _normalizeStyle({ fontSize: `${_ctx.verseTextFontSize * scale}px` })
            }, _toDisplayString(_ctx.verseText), 5))
          : _createCommentVNode("", true),
        (_ctx.spinner)
          ? (_openBlock(), _createElementBlock("p", {
              key: 2,
              class: "verse-text",
              style: _normalizeStyle({ fontSize: `${_ctx.verseTextFontSize * scale}px` })
            }, [
              _createVNode(_component_PlaceholderParagraph, { length: 120 })
            ], 4))
          : _createCommentVNode("", true),
        (_ctx.spinner)
          ? (_openBlock(), _createBlock(_component_Spinner, {
              key: 3,
              class: "qa-qc-spinner",
              delay: 0
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}